import { render, staticRenderFns } from "./PriceVolumeSet.vue?vue&type=template&id=7357cb5a&scoped=true"
import script from "./PriceVolumeSet.vue?vue&type=script&lang=js"
export * from "./PriceVolumeSet.vue?vue&type=script&lang=js"
import style0 from "./PriceVolumeSet.vue?vue&type=style&index=0&id=7357cb5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7357cb5a",
  null
  
)

export default component.exports